var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.234 8.959v4.764a.902.902 0 01-.903.902h-8.97a.902.902 0 01-.902-.902V4.776c0-.498.404-.902.902-.902h4.344m2.485-1.415h3.67c.408.02.728.357.727.765v3.44m-4.703.498l4.489-4.49",
    stroke: "#5F2698",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjIzNCA4Ljk1ODk4VjEzLjcyM0MxMy4yMzQgMTMuODQxNSAxMy4yMTA2IDEzLjk1ODkgMTMuMTY1MiAxNC4wNjg0QzEzLjExOTggMTQuMTc3OSAxMy4wNTMzIDE0LjI3NzQgMTIuOTY5NCAxNC4zNjExQzEyLjg4NTYgMTQuNDQ0OSAxMi43ODYgMTQuNTExMyAxMi42NzY1IDE0LjU1NjZDMTIuNTY2OSAxNC42MDE5IDEyLjQ0OTUgMTQuNjI1MSAxMi4zMzEgMTQuNjI1SDMuMzYwOThDMy4xMjE3NiAxNC42MjUgMi44OTIzMyAxNC41MyAyLjcyMzE3IDE0LjM2MDhDMi41NTQwMiAxNC4xOTE2IDIuNDU4OTggMTMuOTYyMiAyLjQ1ODk4IDEzLjcyM1Y0Ljc3NTk4QzIuNDU4OTggNC4yNzc5OCAyLjg2Mjk4IDMuODczOTggMy4zNjA5OCAzLjg3Mzk4SDcuNzA0OThNMTAuMTkgMi40NTg5OEgxMy44NkMxNC4yNjggMi40Nzg5OCAxNC41ODggMi44MTU5OCAxNC41ODcgMy4yMjM5OFY2LjY2Mzk4TTkuODgzOTggNy4xNjE5OEwxNC4zNzMgMi42NzE5OCIgc3Ryb2tlPSIjNUYyNjk4IiBzdHJva2Utd2lkdGg9IjEuMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgLinkIcon as ReactComponent };